import Header from 'components/Headers/Header';
import moment from 'moment';
import React, { useRef } from 'react';
import { Button, Container, FormGroup, Row } from 'reactstrap';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Services
import { getSessionCookie } from '../../../services/session';
import { useReactToPrint } from 'react-to-print';

//CSS

function HistoricoLocalExecucoes({ handleReturn, historicoLocalExecucao, dataPesquisa }) {
    const session = getSessionCookie();

    const refImprimir = useRef();

    //Função assionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Históricos de locais",
        pageStyle: `
        @media print {
            * {
                overflow: visible !important;
            }
        
            .print-padding {
                padding: 10px;
                /* Ajuste a quantidade de espaço de preenchimento conforme necessário */
            }
        
            html,
            body {
                height: 100%;
                margin: 0 !important;
                padding: 0 !important;
            }
        
            .allowPrint,
            .allowPrint * {
                visibility: visible;
            }
        
            .allowPrint {
                position: absolute;
                width: 100%;
                left: 0;
                top: 0 !important;
                max-width: 100% !important;
                border: none !important;
                margin: 0px !important;
                padding-left: 0px !important;
                padding-right: 0px !important;
            }
        
            .no-print,
            .no-print * {
                display: none !important;
                margin: 0px !important;
                padding: 0px !important;
            }
        
            .imagem-evidencia {
                page-break-inside: avoid;
                padding-top: 10px;
            }
        
            .md-chat-widget-btn-container {
                display: none
            }
        
            .marginTop {
                margin-top: 20px;
            }
        
            div.print {
                padding: 20px !important;
                display: block !important;
            }
        }
        
        .tabela-relatorio th, 
        .tabela-relatorio td{
            padding: 0.25rem !important;
        }
        
        .tabela-relatorio th {
            text-align: center;
        }
        `
    });

    const openImage = (image) => {
        window.open(session.pathVirtual + image);
    }

    return <>
        <Header />
        <Row>
            <Container className="mt--9" fluid>
                <div className='d-flex justify-content-between align-items-center mb-1'>
                    <Button color="secondary" type="button" onClick={() => handleReturn()}>Voltar</Button>
                    <Button color="danger" type="button" onClick={handlePrint}><FontAwesomeIcon icon={faPrint} /> Imprimir</Button>
                </div>
                <div className="card shadow" >
                    <div className='card-body print-padding print' ref={refImprimir}>
                        <div className='row'>
                            <div className={" col-sm-12 col-lg-12 text-center"}>
                                <h2> Histórico de Execução dos Serviços</h2>
                            </div>
                            <div className={"mb-2 col-sm-12 col-lg-12"}>
                                <h3>Local de Execução</h3>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Endereço: </span> <span>{historicoLocalExecucao?.endereco}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Divisão Administrativa:</span> <span>{historicoLocalExecucao?.divisaoAdministrativa}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Área Operacional:</span> <span>{historicoLocalExecucao?.areaOperacioanl}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Modalidade de Serviço:</span> <span>{historicoLocalExecucao?.modalidadeServico}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Categoria:</span> <span>{historicoLocalExecucao?.categoria}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Plano de Trabalho:</span> <span>{historicoLocalExecucao?.planoTrabalho}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Frequência:</span> <span>{historicoLocalExecucao?.frequencia}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Dias da Semana:</span> <span>{historicoLocalExecucao?.diasSemana}</span>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className='col-sm-12 col-lg-12 mb-2'>
                                <h3>Dados de Execução</h3>
                            </div>
                            <div className='col-sm-12 col-lg-12'>
                                <span className='font-weight-bold'>Período: </span> <span>{moment(dataPesquisa?.dataInicio).format("DD/MM/YYYY")} A {moment(dataPesquisa?.dataFim).format("DD/MM/YYYY")}</span>
                            </div>
                            <div className='col-sm-12 col-lg-12 mt-2'>
                                <table className='table-bordered tabela-relatorio w-100' border="1">
                                    <thead className='thead-light'>
                                        <tr>
                                            <th>Programado</th>
                                            <th>Avulso</th>
                                            <th>Execução Total</th>
                                            <th>Execução Parcial</th>
                                            <th>Não Execução</th>
                                            <th>Índice de Atendimento</th>
                                            <th>Índice de Qualidade</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className='text-center font-weight-bold'>
                                            <td>
                                                {historicoLocalExecucao?.programado}
                                            </td>
                                            <td>
                                                {historicoLocalExecucao?.avulso}
                                            </td>
                                            <td>
                                                {historicoLocalExecucao?.execucaoTotal}
                                            </td>
                                            <td>
                                                {historicoLocalExecucao?.execucaoParcial}
                                            </td>
                                            <td>
                                                {historicoLocalExecucao?.naoExecucao}
                                            </td>
                                            <td style={{ background: historicoLocalExecucao?.corIndiceAtendimento, fontWeight: "bold", color: "white" }}>
                                                {historicoLocalExecucao?.condicacaoIndiceAtendimento}
                                            </td>
                                            <td style={{ background: historicoLocalExecucao.corIndiceQualidade, fontWeight: "bold", color: "white" }}>
                                                {historicoLocalExecucao?.condicacaoIndiceQualidade}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-sm-12 col-lg-12 mt-2">
                                <span>Tempo de atuação no local de execução (média): </span> <span>{historicoLocalExecucao?.tempoAtuacaoMedioLocal}</span>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-sm-12 col-lg-12mb-2 " md={12} lg={12}>
                                <h3>Registros Fotográficos</h3>
                            </div>
                        </div>
                        {historicoLocalExecucao?.historicoLocalExecucoesFotos?.map((value, index) => {
                            return (
                                <div className='imagem-evidencia w-100 d-flex flex-column align-items-center mb-3'>
                                    <div className='d-flex justify-content-between h-100 w-100'>
                                        <div className='d-flex flex-column justify-content-center align-items-center mr-4'>
                                            <strong className='mb-1'>Evidências Antes</strong>
                                            <div className="d-flex flex-wrap justify-content-center">
                                                {value?.evidenciaAntes?.map((antes, indexAntes) => {
                                                    return (
                                                        <div key={indexAntes} className='mb-2 mr-2'>
                                                            <img
                                                                alt={"..."}
                                                                height={"220"}
                                                                width={"160"}
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => openImage(antes.imagem)}
                                                                src={session.pathVirtual + antes.imagem}
                                                            />
                                                            <div className='mt-1 text-center'>
                                                                {moment(antes.dataHoraRegisto).format("DD/MM/YYYY HH:mm")}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className='d-flex flex-column justify-content-center align-items-center ml-4'>
                                            <strong className='mb-1'>Evidências Depois</strong>
                                            <div className="d-flex flex-wrap justify-content-center">
                                                {value?.evidenciaDepois?.map((depois, indexDepois) => {
                                                    return (
                                                        <div key={indexDepois} className='mb-2 mr-2'>
                                                            <img
                                                                alt={"..."}
                                                                height={"220"}
                                                                width={"160"}
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => openImage(depois.imagem)}
                                                                src={session.pathVirtual + depois.imagem}
                                                            />
                                                            <div className='mt-1 text-center'>
                                                                {moment(depois.dataHoraRegisto).format("DD/MM/YYYY HH:mm")}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <strong>Qualidade da Execução: </strong> <span>{value.qualidadeExecucao}</span>
                                    </div>
                                </div>
                            );
                        })}
                        <div className='print w-100' style={{ display: "none" }}>
                            <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                        </div>
                    </div>
                </div>
            </Container>
        </Row>
    </>;
}

export default HistoricoLocalExecucoes;